<template>
  <div ref="bankdetails" class="vue-bank-details">
    <vue-loading :active.sync="is_loading" :can-cancel="false" :is-full-page="false"></vue-loading>
    <div class="row">
      <div class="form-group col-md-6" v-bind:class="{ 'has-errors': errors.has('bank') }">
        <v-select
          class="v-dropdown form-control"
          v-model="details.bank"
          placeholder="Bank"
          :options="bank_options"
          :clearable="false"
          v-validate="'required'"
          data-vv-value-path="mutableValue"
          data-vv-name="Bank"
          :has-error="errors.has('bank')"
          @input="getBankAccountTypes"
        ></v-select>
        <span class="error-message">{{ errors.first('bank') }}</span>
      </div>

      <div class="form-group col-md-6" v-bind:class="{ 'has-errors': errors.has('account_type') }">
        <v-select
          class="v-dropdown form-control"
          v-model="details.account_type"
          placeholder="Account Type"
          :options="account_type_options"
          :clearable="false"
          v-validate="'required'"
          data-vv-value-path="mutableValue"
          data-vv-name="Account Type"
          :has-error="errors.has('account_type')"
        ></v-select>
        <span class="error-message">{{ errors.first('account_type') }}</span>
      </div>
    </div>

    <div class="form-group" v-bind:class="{ 'has-errors': errors.has('account_name')}">
      <input
        type="text"
        v-model="details.account_name"
        v-validate="'required'"
        name="account_name"
        class="form-control"
        data-vv-as="Account Name"
        placeholder="Account Name"
      >
      <span class="error-message">{{ errors.first('account_name') }}</span>
    </div>

    <div class="form-group" v-bind:class="{ 'has-errors': errors.has('account_number')}">
      <input
        type="tel"
        v-model="details.account_number"
        v-validate="'required'"
        name="account_number"
        class="form-control"
        data-vv-as="Account Number"
        placeholder="Account Number"
      >
      <span class="error-message">{{ errors.first('account_number') }}</span>
    </div>

    <div class="form-group" v-bind:class="{ 'has-errors': errors.has('branch_code')}">
      <input
        type="tel"
        v-model="details.branch_code"
        v-validate="'required'"
        name="branch_code"
        class="form-control"
        data-vv-as="Branch Code"
        placeholder="Branch Code"
      >
      <span class="error-message">{{ errors.first('branch_code') }}</span>
    </div>

    <div class="row">
      <div class="form-group col-md-12" v-bind:class="{ 'has-errors': errors.has('debit_day') }">
        <v-select
          class="v-dropdown form-control"
          v-model="details.debit_day"
          placeholder="Debit Day"
          :options="debit_day_options"
          :clearable="false"
          data-vv-value-path="mutableValue"
          data-vv-name="DebitDay"
          :has-error="errors.has('debit_day')"
        ></v-select>
        <span class="error-message">{{ errors.first('debit_day') }}</span>
      </div>    
    </div>
  </div>
</template>

<script>
import PaymentService from "@/services/payment.service.js";

export default {
  name: "vue-bank-details",
  props: {
    details: Object,
    bank: Object
  },
  components: {},
  data: function() {
    return {
      is_loading: true,
      bank_options: [],
      account_type_options: [],
      banks: [],
      debit_day_options: [25,31]
    };
  },
  created() {
    var self = this;
    self.getBanks();
  },
  methods: {
    getBanks() {
      var self = this;
      self.is_loading = true;
      PaymentService.getBanks()
        .then(function({ data }) {
          self.is_loading = false;
          if(self.details.bank != null) self.getBankAccountTypes();
          var r = data;
          self.$log.debug("Get banks response", data);
          self.banks = r.data;
          self.banks.forEach(bank => {
            var b = { label: bank.name, value: bank.uid };
            if (self.bank_options.indexOf(b) < 0) self.bank_options.push(b);
          });            
        })
        .catch(function(error) {
          self.$log.error("Get banks error", error);
          self.is_loading = false;
        });
    },
    getBankAccountTypes() {
      var self = this;
      self.is_loading = true;
      self.details.account_type = [];
      self.account_type_options = [];
      PaymentService.getBankAccountTypes(self.details.bank.value)
        .then(function({ data }) {
          self.is_loading = false;
          var r = data;
          self.$log.debug("Get banks response", data);
          var accountTypes = r.data;
          accountTypes.forEach(accType => {
            var b = { label: accType.bank_account_type, value: accType.bank_account_type_uid };
            if (self.account_type_options.indexOf(b) < 0) self.account_type_options.push(b);
          });
        })
        .catch(function(error) {
          self.$log.error("Get banks error", error);
          self.is_loading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
</style> 